module.exports = __webpack_public_path__ + "static/img/index_bk3_icon.d2cd61e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_bk3_icon.png
// module id = wm54
// module chunks = 4